document.addEventListener('DOMContentLoaded', () => {
  const toggles = document.querySelectorAll(
    '.js-menu-toggle, .js-submenu-toggle'
  );

  toggles.forEach(toggle => {
    toggle.addEventListener('click', function (e) {
      const parent = this.parentElement;

      const submenu = parent.querySelector(
        ':scope > .submenu, :scope > .header__submenu'
      );

      if (!submenu) return;

      e.preventDefault();

      const isOpen = submenu.classList.contains('is-open');

      const siblings = parent.parentElement.children;

      [...siblings].forEach(li => {
        const siblingSubmenu = li.querySelector(
          ':scope > .submenu.is-open, :scope > .header__submenu.is-open'
        );

        if (siblingSubmenu && siblingSubmenu !== submenu) {
          siblingSubmenu.classList.remove('is-open');
          siblingSubmenu.previousElementSibling?.setAttribute(
            'aria-expanded',
            'false'
          );
        }
      });
      submenu.classList.toggle('is-open', !isOpen);
      this.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  document.addEventListener('click', e => {
    if (!e.target.closest('.header-dropdown-menu')) {
      document
        .querySelectorAll('.submenu.is-open, .header__submenu.is-open')
        .forEach(menu => {
          menu.classList.remove('is-open');
          menu.previousElementSibling?.setAttribute(
            'aria-expanded',
            'false'
          );
        });
    }
  });
});